import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  CardData,
  EndpointKeys,
  HTTP_HEADERS,
  IDP_APP,
  PaymentReference,
  TIMEOUT
} from '@com-delta-idp/mnx-trip-management-shared-smart';
import {
  ApiBuilder,
  AppConfigService,
  HttpHeadersPayload,
  HttpRequestMethods,
  handleError
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root'
})
export class PaymentReferenceService {
  errorHandler = handleError.bind(this);
  timeout!: number;
  myTripsHeader: HttpHeadersPayload = {
    'Content-Type': HTTP_HEADERS.CONTENT_TYPE,
    appId: HTTP_HEADERS.APP_ID,
    channelId: HTTP_HEADERS.CHANNEL_ID,
    purchasePath: HTTP_HEADERS.PURCHASE_PATH
  };

  constructor(private http: HttpClient, private appConfig: AppConfigService) {
    this.appConfig
      .getConfigValue(IDP_APP, TIMEOUT)
      .subscribe((value: string) => {
        this.timeout = Number(value);
      });
  }

  // Fetches reference ID for credit/debit card
  getCardReferenceId = (cardNumber: string): Observable<PaymentReference> => {
    const requestData: CardData = {
      cardDetails: {
        paymentCardNum: cardNumber
      }
    };

    return new ApiBuilder<CardData, PaymentReference>(this.http, this.appConfig)
      .app(IDP_APP)
      .endpointKey(EndpointKeys.PAYMENT_AWS)
      .method(HttpRequestMethods.POST)
      .payload(requestData)
      .httpHeaders(this.myTripsHeader)
      .errorHandler(this.errorHandler)
      .timeOut(this.timeout)
      .create();
  };
}
